export const COMPANY = {
  name: "Gait Naurish Ltd.",
  address: "A-5-Q, Sector 80, Phase II, Noida, Uttar Pradesh, India",
  phone: "+91 9871847736",
  phoneHref: "tel:+919871847736",
  email: "info@fnni.in",
  website: "www.gaitnaurish.com",
};

export const FOOTNOTE =
  "*Indicative values for illustration, reflecting typical responses reported for feed flavours, attractants and additives. Actual results vary with diet, animals, process and conditions.";

export const RANGES = [
  {
    slug: "palativa",
    name: "PALATIVA",
    category: "Feed Palatability Additives",
    species: "Cattle, buffalo & ruminants",
    tagline: "Make every mouthful inviting.",
    lead: "Each PALATIVA blend pairs aroma with specialised ingredients chosen for animal feed, so cattle and buffalo find their ration faster, accept it and keep eating.",
    intro: "Every kilogram of dry matter an animal eats becomes milk, growth and body condition. Ration changes, heat and bitter or dusty ingredients quietly cut how much it eats. PALATIVA gives feed a familiar, appealing aroma and taste, so animals come to the trough sooner and stay longer.",
    accent: "#1F6B45",
    accent2: "#C8861A",
    tint: "#EAF1E6",
    pack: "/images/pack-palativa.jpg",
    hero: "/images/cow-hand.jpg",
    banner: "/images/w-cows.jpg",
    tile: "/images/cows.jpg",
    photo: "/images/palativa-cow.jpg",
    cutout: true,
    brochure: "/brochures/palativa.pdf",
    dose: "100–500 g/t",
    made: "Noida, Uttar Pradesh",
    stats: [
      { v: "~70%", l: "of feed eaten was PALATIVA feed in two-choice tests*" },
      { v: "≥85%", l: "of aroma retained after steam conditioning at 85 °C*" },
      { v: "+13%", l: "calf starter intake over weeks 1–8 with PALATIVA 301*" },
    ],
    benefits: [
      "Aroma tuned to how ruminants smell",
      "Masks bitter minerals and urea",
      "Sweet notes that sustain intake",
      "Heat-stable, pellet-ready carrier",
    ],
    steps: [
      { t: "Attract", d: "An inviting aroma draws animals to the feed bunk" },
      { t: "Entice", d: "A pleasant taste masks bitter and dusty notes" },
      { t: "Accept", d: "Animals eat steadily and come back for more" },
    ],
    risks: [
      "Weaning and early calf starter",
      "Ration and ingredient changes",
      "Heat stress",
      "Transition and early lactation",
      "Bitter minerals, urea and by-products",
      "Medicated and additive-rich feeds",
    ],
    variants: [
      { code: "101", name: "Fruity banana", notes: "Sweet fruity notes", best: "Calf starter, heifer and young-stock feed", dose: "200–500 g/t", swatch: "#E9C44A" },
      { code: "201", name: "Molasses", notes: "Rich molasses notes", best: "Dairy concentrate, low-molasses rations", dose: "200–500 g/t", swatch: "#6B3A1E" },
      { code: "301", name: "Milky vanilla", notes: "Creamy vanilla notes", best: "Calf starter and pre-weaning feed", dose: "200–500 g/t", swatch: "#EFE2C2" },
      { code: "302", name: "Milky vanilla & coconut", notes: "Milky tropical notes", best: "Calf and heifer feed, premium dairy feed", dose: "200–500 g/t", swatch: "#D9CBB0" },
      { code: "401", name: "Lacto Vanilla Boost", notes: "Fresh milky and vanilla notes with mixed fruit notes", best: "TMR, mineral mixture, straw-based rations", dose: "200–500 g/t", swatch: "#B9D27A" },
      { code: "650", name: "Intense sweetener", notes: "Sweet taste profile", best: "Masks bitterness, pairs with any flavour", dose: "100–150 g/t", swatch: "#F2A93B" },
    ],
    applications: ["Dairy cattle concentrate", "Buffalo feed", "Calf starter", "Heifer and young stock", "TMR and silage-based rations", "Mineral mixture", "Goat and sheep feed"],
    howto: [
      { t: "Pre-blend", d: "Mix with a small portion of the dry ingredients for an even spread." },
      { t: "Add early", d: "Add to the mixer with the dry ingredients, before steam conditioning." },
      { t: "Mix and process", d: "Mix uniformly, then pellet or bag as mash as usual." },
    ],
    specs: [
      ["Appearance", "Free-flowing granules"],
      ["Feed forms", "Mash, pellets, crumbles and mineral mixtures"],
      ["Inclusion", "100–500 g per tonne of finished feed"],
      ["Processing", "Withstands steam conditioning and pelleting"],
      ["Shelf life", "12 months in the original sealed bag"],
      ["Storage", "Cool, dry place below 30 °C, away from sunlight; reseal after use"],
      ["Packing", "25 kg HDPE bag with inner liner"],
      ["Manufactured", "Noida, Uttar Pradesh, India"],
    ],
  },
  {
    slug: "optibite",
    name: "OPTIBITE",
    category: "Fish Feed Palatability Additive",
    species: "Fish & shrimp",
    tagline: "Make every bite inviting.",
    lead: "Specialised for sinking and floating feed, for fish and shrimp. OPTIBITE strengthens the cues that trigger feeding, so animals respond quickly and finish their ration.",
    intro: "Fish and shrimp find feed by smell and taste long before they see it. Every minute a pellet sits uneaten it loses nutrients and aroma to the water, and slow, selective eaters like shrimp may leave it behind.",
    accent: "#0B5F8A",
    accent2: "#22A6C7",
    tint: "#E3F0F4",
    pack: "/images/pack-optibite.jpg",
    hero: "/images/optibite-hero.jpg",
    banner: "/images/w-fishfarm.jpg",
    tile: "/images/tilapia.jpg",
    photo: "/images/tilapia.jpg",
    brochure: "/brochures/optibite.pdf",
    dose: "250 g–1 kg/t",
    made: "AURIC, Aurangabad",
    stats: [
      { v: "−20%", l: "time to finish feed*" },
      { v: "+8%", l: "feed intake*" },
      { v: "−50%", l: "feed left uneaten on check trays*" },
    ],
    benefits: ["Better feed acceptance", "Shorter feed intake time", "Enhanced feed intake", "Helps reduce feed loss"],
    steps: [
      { t: "Detect", d: "Attractant cues spread from each pellet into the water" },
      { t: "Approach", d: "Fish and shrimp home in on the feed quickly" },
      { t: "Ingest", d: "Feed is eaten before it breaks down or leaches" },
    ],
    grades: [
      { name: "Sinking grade", look: "Viscous brown liquid", d: "High in LPC, which also acts as an emulsifier: it improves oil and water emulsification and the digestibility of dietary fats in fish feed.", how: "Dose into the mixer with the mash before conditioning and pelleting." },
      { name: "Floating grade", look: "Low-viscosity liquid", d: "Flows and sprays easily for even coverage on extruded pellets.", how: "Add with the liquids before extrusion, or spray on with the oil coating after drying for the strongest aroma at the water surface." },
    ],
    speciesTable: [
      ["Tilapia", "Floating extruded", "Fry to grow-out", "250 g–1 kg/t"],
      ["Pangasius", "Floating extruded", "Fingerling to grow-out", "250 g–1 kg/t"],
      ["Rohu, catla, mrigal", "Floating or sinking pellet", "Fingerling to grow-out", "250 g–1 kg/t"],
      ["Vannamei shrimp", "Sinking pellet", "Nursery to finishing", "250 g–1 kg/t"],
      ["Black tiger shrimp", "Sinking pellet", "Nursery to finishing", "250 g–1 kg/t"],
    ],
    specs: [
      ["Form", "Liquid — sinking and floating grades"],
      ["Inclusion", "250 g to 1 kg per tonne of finished feed"],
      ["Shelf life", "12 months in the original sealed drum"],
      ["Storage", "Cool, dry place below 30 °C, away from sunlight; close the drum tightly after use"],
      ["Packing", "25 kg HDPE drums"],
      ["Manufactured", "AURIC, Aurangabad, India"],
    ],
  },
  {
    slug: "avitiva",
    name: "AVITIVA",
    category: "Poultry Performance Solutions",
    species: "Broiler, layer & breeder",
    tagline: "More from every gram of feed.",
    lead: "Get more from dietary fat, keep feed moisture in balance, add the strength of curcumin and give every yolk a rich golden-orange colour — for broiler, layer and breeder feed.",
    intro: "AVITIVA brings four focused solutions together under one poultry range: pigmentation, fat emulsification, moisture optimisation and high-strength curcumin.",
    accent: "#B4471A",
    accent2: "#E3A21A",
    tint: "#F6EADF",
    pack: "/images/pack-avitiva.jpg",
    hero: "/images/senzia.jpg",
    banner: "/images/w-poultry.jpg",
    tile: "/images/hen.jpg",
    photo: "/images/hen.jpg",
    brochure: "/brochures/avitiva.pdf",
    dose: "250 g–2 kg/t",
    made: "Noida, Uttar Pradesh",
    stats: [
      { v: "13", l: "yolk colour fan score with low-corn + SENZIA diet*" },
      { v: "+5 pts", l: "fat digestibility in young broilers with LYSOBOOST*" },
      { v: "+3 pts", l: "pellet durability index with PROTIVEX*" },
    ],
    benefits: ["Golden yolk & skin colour", "Better fat utilisation", "Moisture held through the mill", "Standardised curcumin"],
    products: [
      {
        name: "SENZIA", kind: "Yolk pigmentation solution", image: "/images/senzia.jpg", dose: "250–1,250 g/t",
        d: "Apo-ester and canthaxanthin in one balanced blend: a yellow base, then a red drive, for a golden-orange yolk and golden broiler skin.",
        points: ["Yolk pigmentation", "Shank pigmentation", "Roche Yolk Colour Fan working range 11–15"],
      },
      {
        name: "LYSOBOOST", kind: "High-LPC emulsifier for poultry feed", image: "/images/lysoboost.jpg", dose: "250–500 g/t*",
        d: "High LPC + high-HLB surfactant blend. Young birds digest fat better, so you can credit 40–60 kcal/kg energy in formulation.*",
        points: ["Higher fat emulsification", "Higher fat digestibility", "Higher oil utilisation", "Higher growth performance"],
      },
      {
        name: "PROTIVEX", kind: "Poultry feed moisture optimiser", image: "/images/protivex.jpg", dose: "1–2 kg/t*",
        d: "A focused approach to feed moisture: +1 to 1.5 pts moisture held in bagged feed and +3 points pellet durability index.*",
        points: ["Moisture optimisation", "Feed moisture management", "Feed processing support", "Poultry feed applications"],
      },
      {
        name: "CURCUMAX", kind: "High-strength curcumin oleoresin", image: "/images/curcumax.jpg", dose: "1–2 kg/t",
        d: "Strength of curcumin. Colour in every batch. Oil and water dispersible, standardised curcuminoid content, consistent to specification.",
        points: ["High-strength curcumin", "Antimicrobial support", "Improved feed colour", "Every batch to specification"],
      },
    ],
    senziaDose: {
      yolk: [["Fan 9–10", "250–350 g/MT"], ["Fan 11", "350–450 g/MT"], ["Fan 12", "500–650 g/MT"], ["Fan 13", "700–850 g/MT"], ["Fan 14", "900–1,000 g/MT"], ["Fan 15", "1,100–1,250 g/MT"]],
      skin: [["Natural yellow", "250–400 g/MT"], ["Golden", "500–700 g/MT"], ["Deep golden-orange", "800–1,000 g/MT"]],
    },
    curcumaxTable: [
      ["Curcuminoid content", "Variable", "Standardised strength %"],
      ["Mixing", "Poor dispersion", "Oil and water dispersible"],
      ["Consistency", "Varies by lot", "Every batch to specification"],
      ["Inclusion", "—", "1–2 kg per tonne of feed"],
    ],
    specs: [
      ["Range", "SENZIA, LYSOBOOST, PROTIVEX, CURCUMAX"],
      ["Species", "Broiler, layer and breeder feed"],
      ["Inclusion", "SENZIA 250–1,250 g/t · LYSOBOOST 250–500 g/t · PROTIVEX 1–2 kg/t · CURCUMAX 1–2 kg/t"],
      ["Packing", "25 kg HDPE bag with inner liner"],
      ["Manufactured", "Noida, Uttar Pradesh, India"],
    ],
  },
];

export const getRange = (slug) => RANGES.find((r) => r.slug === slug);

export const CHARTS = {
  preference: [
    { code: "101", palativa: 68, control: 32 },
    { code: "201", palativa: 72, control: 28 },
    { code: "301", palativa: 70, control: 30 },
    { code: "302", palativa: 69, control: 31 },
    { code: "401", palativa: 64, control: 36 },
    { code: "650", palativa: 74, control: 26 },
  ],
  aroma: [
    { t: "70 °C", granules: 96, powder: 82 },
    { t: "80 °C", granules: 90, powder: 64 },
    { t: "90 °C", granules: 84, powder: 47 },
  ],
  trays: [
    { stage: "Nursery", control: 18, optibite: 8 },
    { stage: "Grow-out", control: 12, optibite: 5 },
    { stage: "Finishing", control: 10, optibite: 4 },
  ],
  fan: [
    { diet: "Corn-based", score: 4 },
    { diet: "Low-corn", score: 8 },
    { diet: "Low-corn + SENZIA", score: 13 },
  ],
  fat: [
    { day: "D7", control: 72, lysoboost: 79 },
    { day: "D14", control: 80, lysoboost: 80 },
    { day: "D21", control: 84, lysoboost: 88 },
    { day: "D35", control: 86, lysoboost: 89 },
  ],
  moisture: [
    { s: "Mash", control: 16.5, protivex: 11 },
    { s: "Conditioned", control: 15.8, protivex: 11 },
    { s: "Cooled", control: 11.6, protivex: 11.3 },
    { s: "Bagged", control: 10.4, protivex: 10 },
  ],
};

export const SPECIES = [
  { key: "dairy", label: "Dairy cattle & buffalo", range: "palativa", picks: ["PALATIVA 201", "PALATIVA 302", "PALATIVA 401", "PALATIVA 650"], note: "Dairy concentrate, buffalo feed, TMR and mineral mixtures." },
  { key: "calves", label: "Calves & young stock", range: "palativa", picks: ["PALATIVA 101", "PALATIVA 301", "PALATIVA 302", "PALATIVA 650"], note: "Calf starter, pre-weaning, heifer and young-stock feed." },
  { key: "smallrum", label: "Goat & sheep", range: "palativa", picks: ["PALATIVA range", "PALATIVA 650"], note: "Goat and sheep feed, with sweetener to mask bitter notes." },
  { key: "fish", label: "Fish", range: "optibite", picks: ["OPTIBITE Floating grade", "OPTIBITE Sinking grade"], note: "Tilapia, pangasius, rohu, catla and mrigal — fry to grow-out." },
  { key: "shrimp", label: "Shrimp", range: "optibite", picks: ["OPTIBITE Sinking grade"], note: "Vannamei and black tiger shrimp — nursery to finishing." },
  { key: "broiler", label: "Broiler", range: "avitiva", picks: ["LYSOBOOST", "PROTIVEX", "CURCUMAX", "SENZIA (skin & shanks)"], note: "Fat utilisation, moisture, colour and curcumin support." },
  { key: "layer", label: "Layer & breeder", range: "avitiva", picks: ["SENZIA (yolk)", "LYSOBOOST", "PROTIVEX", "CURCUMAX"], note: "Golden-orange yolk colour plus fat and moisture performance." },
];
